import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'

export type TOrderFormPaginateProductService = {
  payload: {
    clientId: string
    orderId: string
    filter?: string
		vigencia: string
    inputValue: string
		filterType?: string;
    tableValueId: string
    isControlProfitability?: boolean
    layoutType?: 'grid' | 'list',
  }
}
export const orderFormPaginateProductService = async ({
  payload,
}: TOrderFormPaginateProductService): Promise<ResponseAPI> => {
  const screenWidth = window.innerWidth;

  let limitPerPage = 0;

  if (payload.layoutType === 'grid' && screenWidth < 1024) {
    limitPerPage = 25;
  } else if (payload.layoutType === 'grid' && screenWidth >= 1024) {
    limitPerPage = 25;
  } else {
    limitPerPage = 25;
  }

  const params: string[] = [
    'paginacaoproduto',
    payload.clientId,
    payload.tableValueId,
		payload.vigencia,
    payload.isControlProfitability,
    payload.orderId,
    limitPerPage,
    payload.filter,
    encodeURIComponent(payload.inputValue),
    payload.filterType,
  ]
    .filter((param) => param !== undefined && param !== null)
    .map(String);

  const url = params.join('/');

  const response = await api.get(url);

  return response.data;
};
